import { render, staticRenderFns } from "./FourRow.vue?vue&type=template&id=13c804fe&scoped=true"
import script from "./FourRow.vue?vue&type=script&lang=js"
export * from "./FourRow.vue?vue&type=script&lang=js"
import style0 from "./FourRow.vue?vue&type=style&index=0&id=13c804fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c804fe",
  null
  
)

export default component.exports